module.exports = __webpack_public_path__ + "static/media/pattern_all.8b2d85c1.svg";